export default __webpack_public_path__ + "static/ncsa-monochrome-665fd635f0e3af7546e5fb1cdb9138a3.png";